import * as yup from 'yup';

export const FundFieldOverrideKey = {
  LpNav: 'lpNav',
} as const;

export type FundFieldOverrideKey = (typeof FundFieldOverrideKey)[keyof typeof FundFieldOverrideKey];

export function fundFieldOverrideFields() {
  return {
    date: yup.string().required(),
    fundId: yup.number().required(),
    key: yup.string().oneOf(Object.values(FundFieldOverrideKey)).required(),
    type: yup.string().required(),
    value: yup.string().required(),
  };
}

export function fundFieldOverrideSchema() {
  return yup.object(fundFieldOverrideFields());
}

export type FundFieldOverride = yup.InferType<ReturnType<typeof fundFieldOverrideSchema>>;
